import isHotkey from 'is-hotkey';
import { Transforms } from 'slate';

import { AulaPlugin } from '../plugins';

/**
 * With default browser behaviour, the shift+(left/right) hotkey stops
 * at each span element, even if it is completely empty. To prevent empty spans
 * from being selected, we override the default behaviour, and instead use Transforms.move to
 * move focus by a single character.
 */
export const handleShiftSelection: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  onKeyDown: (event) => {
    if (editableProps.onKeyDown) editableProps.onKeyDown(event);

    if (isHotkey('shift+right')(event.nativeEvent)) {
      event.preventDefault();
      Transforms.move(editor, {
        unit: 'character',
        distance: 1,
        edge: 'focus',
      });
    } else if (isHotkey('shift+left')(event.nativeEvent)) {
      event.preventDefault();
      Transforms.move(editor, {
        unit: 'character',
        distance: 1,
        edge: 'focus',
        reverse: true,
      });
    }
  },
});
